// Challenge ratings are stored as DOUBLE PRECISION (fractional CRs like 1/3
// arrive as repeating decimals, e.g. 0.3333333333333333). Render the standard
// fractional CRs as fractions; match with an epsilon so any repeating-decimal
// representation maps to its fraction (issue #24).

const CR_FRACTIONS = [
  { value: 1 / 2, label: '1/2' },
  { value: 1 / 3, label: '1/3' },
  { value: 1 / 4, label: '1/4' },
  { value: 1 / 6, label: '1/6' },
  { value: 1 / 8, label: '1/8' },
  { value: 1 / 10, label: '1/10' },
];

const EPSILON = 0.001;

export const formatCR = (cr) => {
  if (cr === null || cr === undefined || cr === '') return '';
  const num = Number(cr);
  if (Number.isNaN(num)) return String(cr);
  if (Number.isInteger(num)) return String(num);
  const fraction = CR_FRACTIONS.find(({ value }) => Math.abs(num - value) < EPSILON);
  return fraction ? fraction.label : String(num);
};

// Values offered by the Monsters CR filter dropdown. The fractional values are
// plain JS numbers whose default string form (e.g. String(1/3) ===
// "0.3333333333333333") is exactly the shortest round-trip representation of
// the stored float8, so `challenge_rating = $1` on the backend still matches.
export const CR_FILTER_VALUES = [
  1 / 10,
  1 / 8,
  1 / 6,
  1 / 4,
  1 / 3,
  1 / 2,
  ...Array.from({ length: 30 }, (_, i) => i + 1),
];
